<template>
  <div class="plazza-page">
    <!-- 头部 -->
    <div class="plazza-header">
      <div class="header-back" @click="$router.go(-1)">
        <svg viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="none" stroke="#fff" stroke-width="2">
          <path d="M15 18l-6-6 6-6"/>
        </svg>
      </div>
      <div class="header-title">发现</div>
    </div>

    <!-- 选项卡 -->
    <div class="plazza-tabs">
      <div class="tabs-wrap">
        <div class="tabs-list">
          <span
            v-for="(tab, idx) in tabs"
            :key="idx"
            class="tab-item"
            :class="{ active: activeTab === idx }"
            @click="switchTab(idx)"
          >{{ tab }}</span>
        </div>
        <div class="tabs-search" @click="handleSearch">
          <svg viewBox="0 0 24 24" width="0.4rem" height="0.4rem" fill="none" stroke="#fff" stroke-width="2">
            <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
          </svg>
        </div>
      </div>
    </div>

    <!-- 全部/关注/收藏/点赞 -->
    <div class="tab-content" v-if="activeTab < 4">
      <div class="post-list" v-if="postList.length > 0">
        <div class="post-item" v-for="(post, idx) in postList" :key="post.id" :class="{ 'is-self': post.is_self }">
          <div class="post-header">
            <div class="post-user-info">
              <img :src="$imgUrl(post.plazza_avatar ? post.plazza_avatar : '/static/newImg/avatar/default.webp')" class="post-avatar" />
              <div class="post-user-text">
                <span class="post-username">{{ post.plazza_username ? post.plazza_username : post.username }}</span>
                <span class="post-fans">{{ post.followers_count || 0 }}位粉丝</span>
              </div>
            </div>
            <div v-if="!post.is_self" class="post-follow-btn" @click="handleFollow(post)">
              {{ post.is_followed ? '已关注' : '+关注' }}
            </div>
          </div>
          <div class="post-content-text">{{ post.content }}</div>
          <div class="post-image-grid" v-if="post.images && parseImages(post.images).length > 0" :class="{
            'grid-1': parseImages(post.images).length === 1,
            'grid-2': parseImages(post.images).length === 2,
            'grid-3': parseImages(post.images).length >= 3
          }">
            <img
              v-for="(img, imgIdx) in parseImages(post.images)"
              :key="imgIdx"
              :src="img"
              class="post-grid-img"
            />
          </div>
          
          <div class="post-footer">
            <span class="post-date">{{ formatTime(post.created_at) }}</span>
            <div class="post-actions">
              <span class="action-item" @click="handleReward(post)">
                <span class="action-icon reward-icon">🎁</span> 打赏
              </span>
              <span class="action-item" @click="handleLike(post)">
                <img :src="post.is_liked ? '/static/newImg/plazza_like_on.svg' : '/static/newImg/plazza_like_off.svg'" class="like-icon-img" /> {{ post.likes_count || 0 }}
              </span>
              <span class="action-item" @click="handleFavorite(post)">
                <img :src="post.is_favorited ? '/static/newImg/plazza_favorite_on.svg' : '/static/newImg/plazza_favorite_off.svg'" class="favorite-icon-img" /> {{ post.favorites_count || 0 }}
              </span>
              <span class="action-item" @click="handleShare(post)"><img src="/static/newImg/plazza_share_icon.svg" class="share-icon-img" /> 分享</span>
            </div>
          </div>

          <div class="post-gift-list" v-if="post.gift_list && post.gift_list.length > 0">
            <div class="gift-list-title">
              <svg class="gift-list-title-icon" viewBox="0 0 24 24" width="20" height="20">
                <path d="M20 12v10H4V12M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" fill="#999" stroke="#999" stroke-width="1"/>
              </svg>
              收到礼物
            </div>
            <div class="gift-list-items">
              <div class="gift-list-item" v-for="gift in post.gift_list" :key="gift.gift_id">
                <img :src="$imgUrl(gift.gift_icon)" class="gift-list-icon" />
                <span class="gift-list-count">x{{ gift.total_count }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 加载中 -->
      <div class="loading" v-if="loading">
        <p>加载中...</p>
      </div>
      <!-- 空状态 -->
      <div class="empty-state" v-if="!loading && postList.length === 0">
        <img src="/static/image/img_none_sj.avif" class="empty-icon" />
        <p class="empty-text">{{ emptyText }}</p>
        <p class="empty-link" v-if="activeTab !== 0" @click="switchTab(0)">返回全部</p>
      </div>
    </div>

    <!-- 我的主页 -->
    <div class="tab-content" v-if="activeTab === 4">
      <div class="my-profile">
        <div class="profile-card">
          <div class="profile-search-bar" v-if="showSearch">
            <input class="profile-search-input" type="text" placeholder="搜索我的帖子" v-model="searchText" @keyup.enter="handleProfileSearch" />
            <span class="profile-search-close" @click="handleSearchClose">
              <span class="close-circle">
                <svg viewBox="0 0 24 24" width="0.3rem" height="0.3rem" fill="#000">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                </svg>
              </span>
            </span>
            <span class="profile-search-btn" @click="handleProfileSearch">
              <svg viewBox="0 0 24 24" width="0.4rem" height="0.4rem" fill="none" stroke="#d1ae52" stroke-width="2">
                <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
              </svg>
            </span>
          </div>
          <div class="profile-header">
            <div class="profile-user-info">
              <img :src="$imgUrl(profileData.plazza_avatar ? profileData.plazza_avatar : '/static/newImg/avatar/default.webp')" class="profile-avatar" :class="{ 'cursor-pointer': !profileData.plazza_username && !profileData.plazza_avatar }" @click="(!profileData.plazza_username && !profileData.plazza_avatar) ? openProfileModal('all') : null" />
              <div class="profile-text">
                <span class="profile-name" :class="{ 'cursor-pointer': !profileData.plazza_username && !profileData.plazza_avatar }" @click="(!profileData.plazza_username && !profileData.plazza_avatar) ? openProfileModal('all') : null">
                  {{ profileData.plazza_username || '请设置昵称' }}
                  <img v-if="!profileData.plazza_username && !profileData.plazza_avatar" src="/static/newImg/plazza_edit_icon.svg" class="edit-icon" />
                </span>
                <span class="profile-fans">{{ profileData.followers_count || 0 }}位粉丝</span>
              </div>
            </div>
            <div class="profile-post-btn" @click="handleCreatePost">+发帖</div>
          </div>
          <div class="profile-intro" :class="{ 'cursor-pointer': profileData.plazza_username && profileData.plazza_avatar && !profileData.plazza_introduce }" @click="(profileData.plazza_username && profileData.plazza_avatar && !profileData.plazza_introduce) ? openProfileModal('intro') : null">
            {{ profileData.plazza_introduce || '请设置个人介绍' }}
            <img v-if="profileData.plazza_username && profileData.plazza_avatar && !profileData.plazza_introduce" src="/static/newImg/plazza_edit_icon.svg" class="intro-edit-icon" />
          </div>
          <div class="profile-stats">
            <div class="stat-item">
              <span class="stat-num">{{ profileData.posts_count || 0 }}</span>
              <span class="stat-label">文章</span>
            </div>
            <div class="stat-item">
              <span class="stat-num">{{ profileData.likes_count || 0 }}</span>
              <span class="stat-label">点赞</span>
            </div>
            <div class="stat-item">
              <span class="stat-num">{{ profileData.favorites_count || 0 }}</span>
              <span class="stat-label">收藏</span>
            </div>
            <div class="stat-actions">
              <span class="stat-action stat-search" @click="showSearch = !showSearch">
                <svg viewBox="0 0 24 24" width="0.4rem" height="0.4rem" fill="none" stroke="#d1ae52" stroke-width="2">
                  <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
                </svg>
              </span>
              <span class="stat-action stat-share">
                <svg viewBox="0 0 24 24" width="0.4rem" height="0.4rem" fill="none" stroke="#d1ae52" stroke-width="2">
                  <path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/>
                </svg>
                <span>分享</span>
              </span>
            </div>
          </div>
          <div class="profile-reward">
            <span><img src="/static/newImg/plazza/icon_moments_gift.avif" class="reward-icon" /> 近7天打赏收入 <span class="reward-amount">{{ profileData.week_rewards_money || '0.00' }}</span></span>
            <span>总打赏收入 <span class="reward-amount">{{ profileData.rewards_money || '0.00' }}</span></span>
          </div>
        </div>

        <!-- 最近在玩 -->
        <div v-if="displayRecentGames && displayRecentGames.length > 0">
          <div class="profile-games-header">
            <span class="games-title">最近在玩</span>
            <span class="games-more" @click="showAllRecentGames = !showAllRecentGames">
              {{ showAllRecentGames ? '收起 ∧' : '更多 ∨' }}
            </span>
          </div>
          <div class="profile-games">
            <div class="game-card" v-for="(game, idx) in displayRecentGames" :key="idx">
              <img :src="game.img" class="game-img" />
              <div class="game-tag" v-if="game.tag">{{ game.tag }}</div>
            </div>
          </div>
        </div>

        <!---自己的帖子--->
        <div class="profile-games-header" v-if="myPostList.length > 0">
          <span class="games-title">发贴列表</span>
        </div>
        <div class="my-posts-wrap" v-if="myPostList.length > 0 || myPostLoading">
          <div class="post-list">
            <div class="post-item is-self" v-for="post in myPostList" :key="post.id">
              <div class="post-header">
                <div class="post-user-info">
                  <img :src="$imgUrl(profileData.plazza_avatar ? profileData.plazza_avatar : '/static/newImg/avatar/default.webp')" class="post-avatar" />
                  <div class="post-user-text">
                    <span class="post-username">{{ profileData.plazza_username || '匿名用户' }}</span>
                    <span class="post-fans">{{ profileData.followers_count || 0 }}位粉丝</span>
                  </div>
                </div>
                <span
                  class="post-status-tag"
                  :class="{
                    'status-pending': post.status === 0,
                    'status-pass': post.status === 1,
                    'status-reject': post.status === 2,
                  }"
                >{{ post.status_text }}</span>
              </div>
              <div class="post-content-text">{{ post.content }}</div>
              <div class="post-image-grid" v-if="post.images && parseImages(post.images).length > 0" :class="{
                'grid-1': parseImages(post.images).length === 1,
                'grid-2': parseImages(post.images).length === 2,
                'grid-3': parseImages(post.images).length >= 3
              }">
                <img
                  v-for="(img, imgIdx) in parseImages(post.images)"
                  :key="imgIdx"
                  :src="img"
                  class="post-grid-img"
                />
              </div>
              <div class="post-footer">
                <span class="post-date">{{ formatTime(post.created_at) }}</span>
                <div class="post-actions">
                  <span class="action-item">
                    <span class="action-icon reward-icon">🎁</span> {{ post.rewards_count || 0 }}
                  </span>
                  <span class="action-item">
                    <img src="/static/newImg/plazza_like_off.svg" class="like-icon-img" /> {{ post.likes_count || 0 }}
                  </span>
                  <span class="action-item">
                    <img src="/static/newImg/plazza_favorite_off.svg" class="favorite-icon-img" /> {{ post.favorites_count || 0 }}
                  </span>
                  <span class="action-item">
                    <img src="/static/newImg/plazza_share_icon.svg" class="share-icon-img" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="my-post-loadmore" v-if="myPostLoading">加载中...</div>
          <div class="my-post-loadmore end" v-else-if="!myPostHasMore && myPostList.length > 0">没有更多了</div>
        </div>
        <div class="empty-state small" v-else-if="!myPostLoading">
          <img src="/static/image/img_none_sj.avif" class="empty-icon" />
          <p class="empty-text">作者还没发帖~</p>
        </div>

      </div>
    </div>

    <!-- 公共打赏弹窗 -->
    <PlazzaRewardModal
      :visible.sync="rewardModalVisible"
      :post="rewardPost"
      @success="onRewardSuccess"
    />

    <!-- 社区资料设置弹窗 -->
    <div class="modal-mask" v-if="showProfileModal" @click.self="closeProfileModal">
      <div class="modal-content profile-modal">
        <div class="profile-modal-tip">{{ profileModalMode === 'intro' ? '编辑个人介绍' : '请先设置头像和昵称才能发帖哦！' }}</div>

        <template v-if="profileModalMode === 'all'">
          <div class="form-field">
            <div class="field-label">请输入您的昵称</div>
            <input
              v-model="profileForm.username"
              type="text"
              placeholder="请输入您的昵称,字数1-20位"
              maxlength="20"
              class="field-input"
            />
          </div>

          <div class="form-field">
            <div class="field-label">请选择您的头像</div>
            <div class="avatar-grid">
              <div
                class="avatar-option"
                v-for="(avatar, idx) in defaultAvatars"
                :key="idx"
                :class="{ active: profileForm.avatar === avatar }"
                @click="profileForm.avatar = avatar"
              >
                <img :src="avatar" class="avatar-option-img" />
              </div>
            </div>
          </div>
        </template>

        <div class="form-field">
          <div class="field-label">个人介绍</div>
          <div class="textarea-wrap">
            <textarea
              v-model="profileForm.introduce"
              placeholder="请输入个人介绍"
              maxlength="500"
              class="field-textarea"
            ></textarea>
            <div class="textarea-count">{{ profileForm.introduce.length }} / 500</div>
          </div>
        </div>

        <div class="profile-modal-actions">
          <div class="action-btn cancel" @click="closeProfileModal">取消</div>
          <div class="action-btn confirm" @click="saveProfileModal">确认</div>
        </div>

        <div class="profile-modal-close" @click="closeProfileModal">×</div>
      </div>
    </div>
  </div>
</template>

<script>
import PlazzaRewardModal from './PlazzaRewardModal.vue';
export default {
  name: 'Plazza',
  components: { PlazzaRewardModal },
  data() {
    return {
      activeTab: 0,
      showSearch: false,
      searchText: '',
      loading: false,
      tabs: ['全部', '关注', '收藏', '点赞', '我的主页'],
      postList: [],
      myPostList: [],
      myPostPage: 1,
      myPostPageSize: 10,
      myPostHasMore: false,
      myPostLoading: false,
      myPostTotal: 0,
      profileData: {
        plazza_username: '',
        plazza_avatar: '',
        plazza_introduce: '',
        posts_count: 0,
        likes_count: 0,
        favorites_count: 0,
        followers_count: 0,
        rewards_money: '0.00',
        week_rewards_money: '0.00',
      },
      page: 1,
      pageSize: 10,
      currentUserInfo: {
        plazza_username: '',
        plazza_avatar: '',
      },
      showProfileModal: false,
      profileForm: {
        username: '',
        avatar: '',
        introduce: '',
      },
      profileSubmitting: false,
      profileModalMode: 'all', // all=完整表单  intro=仅个人介绍
      defaultAvatars: (function(){
        var arr = [];
        for (var i = 1; i <= 30; i++) {
          arr.push('/static/image/avatar/avatar_' + i + '.avif');
        }
        return arr;
      })(),
      recentGames: [],
      showAllRecentGames: false,
      remenGameNames: ['FC电子.avif','KY21点.avif','PG双囍临门.avif','PG宝石传奇.avif','JDB芝麻开门.avif','KY通比牛牛.avif','PG金钱兔.avif','PG澳门壕梦.avif','WG捕鱼达人.avif','PG快钱来了.avif','WG抢庄牛牛.avif','JDB飞鸟派对.avif','KY极速炸金花.avif','WG红黑大战.avif','BBIN糖果派对-极速版.avif','BBIN糖果派对3.avif','JDB三倍金刚.avif','CQ9跳起来.avif','KY看牌抢庄牛牛.avif','MG花花公子.avif','PG火树赢花.avif','LEG金鲨银鲨.avif','PG恐龙帝国.avif','MG淑女派对.avif','CQ9跳高高.avif','WG体育.avif','WG炸金花.avif','WG财神捕鱼.avif','MG冰球突破.avif','KY押庄龙虎.avif','PG夜醉佳人.avif','PG麒麟送宝.avif','PG少林足球.avif','PG爱尔兰精灵.avif','PG十倍金牛.avif','PG亡灵大盗.avif','PG福运象财神.avif','PG招财喵.avif','BBIN糖果派对2.avif','BBIN糖果派对.avif','JDB变脸.avif','CQ9跳更高.avif','DB真人.avif','BS棋牌.avif','JDB五龙捕鱼.avif','MG冰球突破豪华版.avif','KY抢庄牛牛.avif','寻宝黄金城.avif','赏金船长.avif','CQ9捕鱼.avif','开元捕鱼.avif','FC捕鱼.avif','WL捕鱼.avif','LEG棋牌.avif','FG电子.avif','IM体育.avif','BBIN彩票.avif','YGR捕鱼.avif','CHOICE捕鱼.avif','BBIN捕鱼.avif','PP电子.avif','FG棋牌.avif','BG捕鱼.avif','BG真人.avif','BS捕鱼.avif','JDB电子.avif','CHOICE电子.avif','CQ9电子.avif','MG电子.avif','BBIN真人.avif','明日派对.avif','氮能夺宝.avif','BBIN电子.avif','开元棋牌.avif','WL真人.avif','JDB捕鱼.avif','CHOICE真人.avif','WG棋牌.avif','龙之连环-黄金盛世.avif','龙之连环-喜悦富足.avif','WG捕鱼.avif','WL棋牌.avif','赏金大对决.avif','赏金女王.avif','财神捕鱼.avif','WG电子.avif','PG电子.avif','麻将胡了2.avif','麻将胡了.avif'],
      actionLocks: {}, // 冷却时间记录：key为操作类型+ID，value为上次点击时间戳
      rewardModalVisible: false,
      rewardPost: null,
    };
  },
  computed: {
    emptyText() {
      const texts = {
        1: '还没有关注任何人',
        2: '还没收藏，快去收藏更多你喜欢的文章',
        3: '还没点过赞，快来点赞',
      };
      return texts[this.activeTab] || '还没有相关内容';
    },
    displayRecentGames() {
      if (!this.recentGames || this.recentGames.length === 0) return [];
      return this.showAllRecentGames ? this.recentGames : this.recentGames.slice(0, 4);
    },
  },
  created() {
    // 随机选择最近在玩的游戏（从remen目录随机打乱取12个）
    var pool = this.remenGameNames.slice();
    for (var i = pool.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = pool[i]; pool[i] = pool[j]; pool[j] = tmp;
    }
    var count = Math.min(12, pool.length);
    var games = [];
    for (var k = 0; k < count; k++) {
      games.push({ img: '/static/newImg/index/game/remen/' + pool[k], tag: '' });
    }
    this.recentGames = games;

    this.loadPosts();
    this.loadCurrentUserInfo();
    // 设置全局刷新函数，供发帖页面调用
    window.__plazzaRefresh = () => {
      if (this.activeTab === 4) {
        this.loadMyProfile();
      } else {
        this.loadPosts();
      }
    };
  },
  mounted() {
    this.__handleWindowScroll = () => {
      // 只在我的主页tab下触发我的帖子的分页加载
      if (this.activeTab !== 4) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const viewHeight = window.innerHeight || document.documentElement.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight || 0;
      // 距底部50px触发加载
      if (scrollHeight - (scrollTop + viewHeight) < 50) {
        if (!this.myPostLoading && this.myPostHasMore) {
          this.myPostPage += 1;
          this.loadMyPosts(false);
        }
      }
    };
    window.addEventListener('scroll', this.__handleWindowScroll, { passive: true });
  },
  beforeDestroy() {
    if (this.__handleWindowScroll) {
      window.removeEventListener('scroll', this.__handleWindowScroll);
    }
  },
  activated() {
    // 页面激活时检查是否需要刷新
    if (window.__plazzaNeedRefresh) {
      window.__plazzaNeedRefresh = false;
      if (this.activeTab === 4) {
        this.loadMyProfile();
      } else {
        this.page = 1;
        this.postList = [];
        this.loadPosts();
      }
    }
  },
  methods: {
    // 加载当前用户信息
    loadCurrentUserInfo() {
      this.$apiFun.post('/api/plazza/myprofile').then(res => {
        if (res.code === 200) {
          this.currentUserInfo.plazza_username = res.data.plazza_username || '';
          this.currentUserInfo.plazza_avatar = res.data.plazza_avatar || '';
        }
      }).catch(e => {
        console.error('加载用户信息失败', e);
      });
    },
    // 检查用户是否设置了社区昵称和头像
    checkUserProfile() {
      if (!this.currentUserInfo.plazza_username || !this.currentUserInfo.plazza_avatar) {
        this.openProfileModal('all');
        return false;
      }
      return true;
    },
    // 冷却时间检查：3秒内重复点击提示"你点击的太快了"
    checkCooldown(key) {
      const now = Date.now();
      const lastTime = this.actionLocks[key] || 0;
      if (now - lastTime < 3000) {
        this.$toast('你点击的太快了');
        return false;
      }
      this.actionLocks[key] = now;
      return true;
    },
    // 切换选项卡
    switchTab(idx) {
      this.activeTab = idx;
      if (idx === 4) {
        this.loadMyProfile();
      } else {
        this.page = 1;
        this.postList = [];
        this.loadPosts();
      }
    },
    // 获取帖子列表
    loadPosts() {
      this.loading = true;
      const typeMap = { 0: 'all', 1: 'follow', 2: 'favorite', 3: 'like' };
      const params = {
        type: typeMap[this.activeTab] || 'all',
        page: this.page,
        pageSize: this.pageSize,
      };
      this.$apiFun.post('/api/plazza/posts', params).then(res => {
        if (res.code === 200) {
          this.postList = res.data.list || [];
        }
      }).catch(e => {
        console.error('加载帖子失败', e);
      }).then(() => {
        this.loading = false;
      });
    },
    // 获取我的主页信息
    loadMyProfile() {
      this.loading = true;
      this.$apiFun.post('/api/plazza/myprofile').then(res => {
        if (res.code === 200) {
          this.profileData = res.data;
        }
      }).catch(e => {
        console.error('加载主页信息失败', e);
      }).then(() => {
        this.loading = false;
      });
      // 同时加载第一页帖子
      this.myPostPage = 1;
      this.loadMyPosts(true);
    },
    // 加载我的帖子列表（分页）
    loadMyPosts(reset) {
      if (reset) {
        this.myPostPage = 1;
        this.myPostHasMore = false;
        this.myPostList = [];
        this.myPostTotal = 0;
      }
      if (this.myPostLoading) return;
      if (!reset && !this.myPostHasMore && this.myPostList.length > 0) return;
      this.myPostLoading = true;
      this.$apiFun.post('/api/plazza/myposts', {
        page: this.myPostPage,
        pageSize: this.myPostPageSize,
        keyword: this.searchText.trim(),
      }).then(res => {
        if (res.code === 200) {
          const data = res.data || {};
          if (reset) {
            this.myPostList = data.list || [];
          } else {
            this.myPostList = this.myPostList.concat(data.list || []);
          }
          this.myPostTotal = data.total || 0;
          this.myPostHasMore = !!data.has_more;
        }
      }).catch(e => {
        console.error('加载我的帖子失败', e);
      }).then(() => {
        this.myPostLoading = false;
      });
    },
    // 解析图片JSON
    parseImages(images) {
      if (!images) return [];
      var self = this;
      var makeFullUrl = function (src) {
        return self.$imgUrl(src);
      };
      if (Array.isArray(images)) return images.map(makeFullUrl);
      try {
        const parsed = JSON.parse(images);
        if (Array.isArray(parsed)) return parsed.map(makeFullUrl);
        return [makeFullUrl(images)];
      } catch (e) {
        return [makeFullUrl(images)];
      }
    },
    // 格式化时间
    formatTime(time) {
      if (!time) return '';
      const date = new Date(time);
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      const h = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      return `${y}/${m}/${d} ${h}:${min}`;
    },
    // 点赞
    handleLike(post) {
      const lockKey = 'like_' + post.id;
      if (!this.checkCooldown(lockKey)) return;
      if (post.is_self) return;
      if (!this.checkUserProfile()) return;
      this.$apiFun.post('/api/plazza/post/like', {
        post_id: post.id,
      }).then(res => {
        if (res.code === 200) {
          post.is_liked = res.data.is_liked;
          post.likes_count = res.data.likes_count;
          this.$toast(res.data.is_liked ? '点赞成功' : '取消点赞');
        }
      }).catch(e => {
        console.error('点赞失败', e);
      });
    },
    // 收藏
    handleFavorite(post) {
      const lockKey = 'fav_' + post.id;
      if (!this.checkCooldown(lockKey)) return;
      if (post.is_self) return;
      if (!this.checkUserProfile()) return;
      this.$apiFun.post('/api/plazza/post/favorite', {
        post_id: post.id,
      }).then(res => {
        if (res.code === 200) {
          post.is_favorited = res.data.is_favorited;
          post.favorites_count = res.data.favorites_count;
          this.$toast(res.data.is_favorited ? '收藏成功' : '取消收藏');
        }
      }).catch(e => {
        console.error('收藏失败', e);
      });
    },
    // 关注
    handleFollow(post) {
      const lockKey = 'follow_' + post.user_id;
      if (!this.checkCooldown(lockKey)) return;
      if (!this.checkUserProfile()) return;
      if (!post.user_id) {
        this.$toast('用户信息错误');
        return;
      }
      this.$apiFun.post('/api/plazza/post/follow', {
        follow_user_id: post.user_id,
      }).then(res => {
        if (res.code === 200) {
          post.is_followed = res.data.is_followed;
          this.$toast(res.data.is_followed ? '关注成功' : '取消关注');
        }
      }).catch(e => {
        console.error('关注失败', e);
      });
    },
    // 打赏
    handleReward(post) {
      if (post.is_self) return;
      if (!this.checkUserProfile()) return;
      this.rewardPost = post;
      this.rewardModalVisible = true;
    },
    // 打赏成功回调，刷新当前帖子统计
    onRewardSuccess(data) {
      var targetPost = (this.postList || []).find(p => p.id === (this.rewardPost && this.rewardPost.id));
      if (targetPost && data) {
        if (typeof data.rewards_count !== 'undefined') targetPost.rewards_count = data.rewards_count;
        if (typeof data.gift_list !== 'undefined') targetPost.gift_list = data.gift_list;
      }
      if ((this.activeTab === 4) && this.rewardPost) {
        var myPost = (this.myPostList || []).find(p => p.id === this.rewardPost.id);
        if (myPost && data) {
          if (typeof data.rewards_count !== 'undefined') myPost.rewards_count = data.rewards_count;
          if (typeof data.gift_list !== 'undefined') myPost.gift_list = data.gift_list;
        }
      }
    },
    // 发帖
    handleCreatePost() {
      if (!this.checkUserProfile()) return;
      this.$router.push('/plazzaPost');
    },
    // 分享
    handleShare(post) {
      if (!this.checkUserProfile()) return;
      this.$toast('分享功能开发中');
    },
    // 打开资料设置弹框
    openProfileModal(mode) {
      this.profileModalMode = mode || 'all';
      this.profileForm.username = this.profileData.plazza_username || '';
      this.profileForm.avatar = this.profileData.plazza_avatar || (this.defaultAvatars.length ? this.defaultAvatars[0] : '');
      this.profileForm.introduce = this.profileData.plazza_introduce || '';
      this.showProfileModal = true;
    },
    // 关闭资料设置弹框
    closeProfileModal() {
      this.showProfileModal = false;
    },
    // 保存资料
    saveProfileModal() {
      if (this.profileSubmitting) return;
      if (this.profileModalMode === 'all') {
        if (!this.profileForm.username.trim()) {
          this.$toast('请输入昵称');
          return;
        }
        if (this.profileForm.username.length < 1 || this.profileForm.username.length > 20) {
          this.$toast('昵称为1-20位');
          return;
        }
        if (!this.profileForm.avatar) {
          this.$toast('请选择头像');
          return;
        }
      }
      this.profileSubmitting = true;
      var payload = {};
      if (this.profileModalMode === 'all') {
        payload.plazza_username = this.profileForm.username.trim();
        payload.plazza_avatar = this.profileForm.avatar;
      }
      payload.plazza_introduce = this.profileForm.introduce.trim();
      this.$apiFun.post('/api/plazza/updateProfile', payload).then(res => {
        if (res.code === 200) {
          this.$toast('设置成功');
          this.showProfileModal = false;
          // 刷新本地数据
          if (this.profileModalMode === 'all') {
            this.currentUserInfo.plazza_username = this.profileForm.username.trim();
            this.currentUserInfo.plazza_avatar = this.profileForm.avatar;
          }
          this.profileData.plazza_username = this.profileForm.username.trim() || this.profileData.plazza_username;
          this.profileData.plazza_avatar = this.profileForm.avatar || this.profileData.plazza_avatar;
          this.profileData.plazza_introduce = this.profileForm.introduce.trim();
        } else {
          this.$toast(res.msg || '保存失败');
        }
        this.profileSubmitting = false;
      }).catch(e => {
        console.error('保存失败', e);
        this.$toast('保存失败');
        this.profileSubmitting = false;
      });
    },
    // 搜索
    handleSearch() {
      this.$router.push('/plazzaSearch');
    },
    handleProfileSearch() {
      if (this.searchText.trim()) {
        this.loadMyPosts(true);
      }
    },
    handleSearchClose() {
      if (this.searchText) {
        this.searchText = '';
        this.loadMyPosts(true);
      } else {
        this.showSearch = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.plazza-page {
  min-height: 100vh;
  background: #0a0a0a;
  color: #fff;
  padding-bottom: 1rem;
}

.plazza-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 1.1rem;
  background: #1a1a1a;

  .header-back {
    position: absolute;
    left: 0.3rem;
    display: flex;
    align-items: center;
  }

  .header-title {
    font-size: 0.4rem;
    font-weight: normal;
    color: #fff;
  }
}

.plazza-tabs {
  background: #1a1a1a;
  border-bottom: 1px solid #333;

  .tabs-wrap {
    display: flex;
    align-items: center;
    padding: 0 0.3rem;
    overflow-x: auto;

    .tabs-list {
      flex: 0 0 75%;
      display: flex;
      overflow-x: auto;
    }

    .tabs-search {
      flex: 0 0 25%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0.25rem 0;
      cursor: pointer;
    }

    .tab-item {
      flex: 0 0 auto;
      padding: 0.25rem 0.2rem;
      font-size: 0.35rem;
      color: #999;
      position: relative;

      &.active {
        color: #d1ae52;

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 0.6rem;
          height: 2px;
          background: #d1ae52;
        }
      }
    }
  }
}

.tab-content {
  padding: 0.3rem 0;
  margin: 0 0.3rem;
}

/* 全部 - 帖子列表 */
.post-list {
  .post-item {
    padding: 0.3rem;
    background: #1a1a1a;
    border-bottom: 1px solid #1a1a1a;
  }

  .post-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.2rem;
  }

  .post-user-info {
    display: flex;
    align-items: center;

    .post-avatar {
      width: 0.8rem;
      height: 0.8rem;
      border-radius: 50%;
      margin-right: 0.2rem;
    }

    .post-user-text {
      display: flex;
      flex-direction: column;

      .post-username {
        font-size: 0.35rem;
        color: #fff;
      }

      .post-fans {
        font-size: 0.24rem;
        color: #999;
        margin-top:0.1rem;
      }
    }
  }

  .post-follow-btn {
    padding: 0.1rem 0.3rem;
    font-size: 0.28rem;
    color: #703904;
    background: #d1ae52;
    border-radius: 0.1rem;
  }

  .post-status-tag {
    padding: 0.08rem 0.2rem;
    font-size: 0.32rem;
    color: #fff;
    border-radius: 0.1rem;

    &.status-pending {
      background: #ffaa09;
    }
    &.status-pass {
      background: #07c160;
    }
    &.status-reject {
      background: #fa5151;
    }
  }

  .post-content-text {
    font-size: 0.35rem;
    color: #e3e3e3;
    margin-bottom: 0.2rem;
  }

  .post-image-grid {
    display: grid;
    gap: 0.1rem;
    margin-bottom: 0.2rem;

    &.grid-1 {
      grid-template-columns: 1fr;

      .post-grid-img {
        width: 100%;
        height: 4rem;
        object-fit: cover;
        border-radius: 0.1rem;
      }
    }

    &.grid-2 {
      grid-template-columns: repeat(2, 1fr);
      grid-auto-rows: 1fr;

      .post-grid-img {
        width: 100%;
        height: auto;
        object-fit: cover;
        border-radius: 0.1rem;
        aspect-ratio: 1 / 1;
        display: block;
      }
    }

    &.grid-3 {
      grid-template-columns: repeat(3, 1fr);
      grid-auto-rows: 1fr;

      .post-grid-img {
        width: 100%;
        height: auto;
        object-fit: cover;
        border-radius: 0.1rem;
        aspect-ratio: 1 / 1;
        display: block;
      }
    }
  }

  .post-gift-list {
    background: #0a0a0a;
    padding: 0.2rem;
    display: flex;
    align-items: center;
    gap: 0.2rem;
    margin-bottom: 0.15rem;

    .gift-list-title {
      font-size: 0.3rem;
      color: #fff;
      white-space: nowrap;
      display: flex;
      align-items: center;
      gap: 0.08rem;

      .gift-list-title-icon {
        width: 0.35rem;
        height: 0.35rem;
        display: inline-block;
      }
    }

    .gift-list-items {
      display: flex;
      align-items: center;
      gap: 0.15rem;
      flex-wrap: wrap;
    }

    .gift-list-item {
      display: flex;
      align-items: center;
      gap: 0.08rem;
    }

    .gift-list-icon {
      width: 0.45rem;
      height: 0.45rem;
      object-fit: contain;
    }

    .gift-list-count {
      font-size: 0.28rem;
      color: #e3e3e3;
    }
  }

  .post-footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .post-date {
      font-size: 0.35rem;
      color: #999;
    }

    .post-actions {
      display: flex;
      gap: 0.3rem;

      .action-item {
        font-size: 0.36rem;
        color: #999;
        display: flex;
        align-items: center;
        gap: 0.08rem;

        .action-icon {
          font-size: 0.5rem;
          line-height: 1;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }

        .action-icon.reward-icon {
          font-size: 0.45rem;
          width: 0.45rem;
          height: 0.45rem;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          line-height: 1;
        }

        .like-icon-img,
        .favorite-icon-img {
          width: 0.45rem;
          height: 0.45rem;
          display: inline-block;
          object-fit: contain;
        }

        .share-icon-img {
          width: 0.45rem;
          height: 0.45rem;
          display: inline-block;
          object-fit: contain;
        }
      }

    }
  }
}

.post-list .post-item.is-self {
  .post-footer .post-actions .action-item {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  }
}

/* 关注 */
.follow-empty {
  padding: 0;

  .follow-empty-text {
    text-align: center;
    font-size: 0.3rem;
    color: #999;
    margin-bottom: 0.4rem;
  }
}

.follow-recommend {
  .follow-user-card {
    display: flex;
    align-items: center;
    background: #1a1a1a;
    border-radius: 0.2rem;
    padding: 0.25rem;
    margin-bottom: 0.3rem;
    gap: 0.2rem;
    width: 50%;

    .follow-user-avatar {
      width: 1.5rem;
      height: 1.5rem;
      border-radius: 50%;
      margin-right: 0.2rem;
    }

    .follow-user-info {
      flex: 0 0 40%;
      display: flex;
      flex-direction: column;

      .follow-user-name {
        font-size: 0.32rem;
        color: #fff;
      }

      .follow-user-fans {
        margin-top: 0.2rem;
        font-size: 0.24rem;
        color: #999;
      }
    }

    .follow-check {
      width: 0.5rem;
      height: 0.5rem;
      background: #d1ae52;
      border: 1px solid #d1ae52;
      border-radius: 0.1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &.checked {
        background: #d1ae52;
        border-color: #d1ae52;
      }

      &:not(.checked) {
        background: transparent;
        border: 1px solid #666d;
      }
    }
  }

  .follow-btn-group {
    display: flex;
    gap: 0.2rem;

    .follow-btn {
      flex: 1;
      text-align: center;
      padding: 0.25rem 0;
      font-size: 0.32rem;
      border-radius: 0.1rem;

      &.skip {
        color: #d1ae52;
        border: 1px solid #d1ae52;
        background: transparent;
      }

      &.confirm {
        color: #703904;
        background: #d1ae52;
        border: 1px solid #d1ae52;
        &.disabled {
          color: #fff;
          background: #666666;
          border: 1px solid #d1ae52;
        }
      }
    }
  }
}

/* 空状态 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 0;

  &.small {
    padding: 1rem 0;
  }

  .empty-icon {
    width: 3rem;
    height: 3rem;
    opacity: 0.5;
    margin-bottom: 0.3rem;
  }

  .empty-text {
    font-size: 0.35rem;
    color: #666;
    margin-bottom: 0.2rem;
  }

  .empty-link {
    font-size: 0.3rem;
    color: #d1ae52;
  }
}

/* 我的主页 */
.my-profile {
  padding: 0;

  .profile-card {
    background: #1a1a1a;
    border-radius: 0.2rem;
    padding: 0.3rem;

    .profile-search-bar {
      display: flex;
      align-items: center;
      background: #0a0a0a;
      border: 1px solid #666666;
      border-radius: 0.5rem;
      padding: 0.2rem 0.2rem;
      margin-bottom: 0.3rem;
      transition: border-color 0.2s;

      &:focus-within {
        border-color: #d1ae52;
      }

      .profile-search-input {
        flex: 1;
        background: transparent;
        border: none;
        outline: none;
        color: #fff;
        font-size: 0.35rem;

        &::placeholder {
          color: #666;
          font-size: 0.35rem;
        }
      }

      .profile-search-close {
        display: flex;
        align-items: center;
        margin-right: 0.35rem;

        .close-circle {
          width: 0.4rem;
          height: 0.4rem;
          border-radius: 50%;
          background: #666666;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .profile-search-btn {
        display: flex;
        align-items: center;
      }
    }
  }

  .profile-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.2rem;
  }

  .profile-user-info {
    display: flex;
    align-items: center;

    .profile-avatar {
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
      margin-right: 0.2rem;
    }

    .profile-avatar.cursor-pointer,
    .profile-name.cursor-pointer,
    .profile-intro.cursor-pointer {
      cursor: pointer;
    }

    .profile-text {
      display: flex;
      flex-direction: column;

      .profile-name {
        font-size: 0.32rem;
        color: #fff;
        display: inline-flex;
        align-items: center;
        gap: 0.1rem;

        .edit-icon {
          width: 0.44rem;
          height: 0.44rem;
          display: inline-block;
        }
      }

      .profile-fans {
        margin-top: 0.1rem;
        font-size: 0.25rem;
        color: #999;
      }
    }
  }

  .profile-post-btn {
    padding: 0.1rem 0.35rem;
    font-size: 0.28rem;
    color: #703904;
    background: #d1ae52;
    border-radius: 0.1rem;
  }

  .profile-intro {
    font-size: 0.3rem;
    color: #fff;
    margin-bottom: 0.3rem;
    display: flex;
    align-items: center;
    gap: 0.1rem;

    .intro-edit-icon {
      width: 0.4rem;
      height: 0.4rem;
      display: inline-block;
      flex-shrink: 0;
    }
  }

  .profile-stats {
    display: flex;
    align-items: center;
    margin-bottom: 0.3rem;

    .stat-item {
      text-align: center;
      margin-right: 0.5rem;

      .stat-num {
        display: block;
        font-size: 0.35rem;
        color: #fff;
      }

      .stat-label {
        font-size: 0.32rem;
        color: #666666;
      }
    }

    .stat-actions {
      margin-left: auto;
      display: flex;
      align-items: center;
      gap: 0.3rem;

      .stat-action {
        display: flex;
        align-items: center;
        gap: 0.1rem;
        font-size: 0.26rem;
        color: #d1ae52;
      }

      .stat-share {
        font-size: 0.3rem;
      }
    }
  }

  .profile-reward {
    display: flex;
    justify-content: space-between;
    font-size: 0.26rem;
    color: #999;
    padding: 0.2rem 0;
    border-top: 1px solid #2a2a2a;
    border-bottom: 1px solid #2a2a2a;

    .reward-icon {
      width: 0.32rem;
      height: 0.32rem;
      vertical-align: middle;
      margin-right: 0.05rem;
    }

    .reward-amount {
      color: #ffaa09;
    }
  }

  .profile-games-header {
    display: flex;
    justify-content: space-between;
    margin: 0.3rem 0;

    .games-title {
      font-size: 0.32rem;
      color: #fff;
    }

    .games-more {
      font-size: 0.3rem;
      color: #d1ae52;
    }
  }

  .profile-games {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.25rem;
    margin-bottom: 0.3rem;

    .game-card {
      position: relative;
      width: 100%;
      border-radius: 0.15rem;
      overflow: hidden;

      .game-img {
        width: 100%;
        display: block;
      }

      .game-tag {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 0.1rem 0.15rem;
        font-size: 0.24rem;
        color: #fff;
      }
    }
  }

  .my-posts-wrap {
    margin-top: 0.2rem;
  }

  .my-post-list {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
  }

  .my-post-item {
    background-color: #1a1a1a;
    border-radius: 0.2rem;
    padding: 0.25rem;
  }

  .my-post-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.15rem;

    .my-post-status {
      display: inline-block;
      padding: 0.05rem 0.15rem;
      border-radius: 0.1rem;
      font-size: 0.22rem;
      color: #fff;

      &.status-pending {
        background-color: #ffaa09;
      }
      &.status-pass {
        background-color: #07c160;
      }
      &.status-reject {
        background-color: #fa5151;
      }
    }

    .my-post-time {
      font-size: 0.22rem;
      color: #888;
    }
  }

  .my-post-content {
    font-size: 0.28rem;
    color: #fff;
    line-height: 1.5;
    margin-bottom: 0.15rem;
  }

  .my-post-imgs {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.1rem;
    margin-bottom: 0.15rem;

    .my-post-img {
      width: 100%;
      border-radius: 0.1rem;
      aspect-ratio: 1 / 1;
      object-fit: cover;
      display: block;
    }
  }

  .my-post-stats {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    font-size: 0.24rem;
    color: #888;
    padding-top: 0.15rem;
    border-top: 1px solid #2a2a2a;

    .my-post-stat {
      display: flex;
      align-items: center;
      gap: 0.05rem;
    }

    .mini-icon {
      width: 0.3rem;
      height: 0.3rem;
      display: inline-block;
    }
  }

  .my-post-loadmore {
    text-align: center;
    font-size: 0.24rem;
    color: #888;
    padding: 0.3rem 0;

    &.end {
      color: #555;
    }
  }
}

/* 加载中 */
.loading {
  text-align: center;
  padding: 1rem 0;
  color: #999;
  font-size: 0.3rem;
}

/* 点赞/收藏激活状态 */
.post-actions {
  .action-item {
    cursor: pointer;
    transition: color 0.2s;

    &:active {
      opacity: 0.7;
    }

    .action-icon.liked {
      color: #ff4757;
    }

    .action-icon.favorited {
      color: #ffd700;
    }
  }
}

/* 模态框 */
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.modal-content {
  width: 80%;
  max-width: 6rem;
  background: #1a1a1a;
  border-radius: 0.3rem;
  overflow: hidden;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.3rem;
  font-size: 0.35rem;
  color: #fff;
  border-bottom: 1px solid #333;
}

.modal-close {
  font-size: 0.5rem;
  color: #999;
  cursor: pointer;
  line-height: 1;
}

.modal-body {
  padding: 0.3rem;
}

.modal-footer {
  padding: 0.3rem;
  border-top: 1px solid #333;
}

/* 发帖 */
.post-textarea {
  width: 100%;
  min-height: 2rem;
  background: #0a0a0a;
  border: 1px solid #333;
  border-radius: 0.2rem;
  padding: 0.2rem;
  color: #fff;
  font-size: 0.32rem;
  resize: none;
  outline: none;

  &::placeholder {
    color: #666;
  }

  &:focus {
    border-color: #d1ae52;
  }
}

.post-submit-btn {
  background: #d1ae52;
  color: #703904;
  font-size: 0.35rem;
  text-align: center;
  padding: 0.2rem 0;
  border-radius: 0.2rem;
  cursor: pointer;
  font-weight: 500;

  &:active {
    opacity: 0.8;
  }
}

/* 礼物选择 */
.gift-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.2rem;
  margin-bottom: 0.3rem;
}

.gift-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.2rem;
  background: #0a0a0a;
  border: 2px solid transparent;
  border-radius: 0.2rem;
  cursor: pointer;
  transition: border-color 0.2s;

  &.active {
    border-color: #d1ae52;
    background: #2a2a2a;
  }

  .gift-icon {
    width: 0.8rem;
    height: 0.8rem;
    margin-bottom: 0.1rem;
  }

  .gift-name {
    font-size: 0.26rem;
    color: #fff;
    margin-bottom: 0.05rem;
  }

  .gift-price {
    font-size: 0.24rem;
    color: #d1ae52;
  }
}

.gift-count {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  margin-bottom: 0.3rem;

  span {
    font-size: 0.3rem;
    color: #fff;
  }

  .count-btn {
    width: 0.6rem;
    height: 0.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #333;
    border-radius: 50%;
    cursor: pointer;
    font-size: 0.35rem;
    color: #fff;

    &:active {
      background: #555;
    }
  }

  .count-num {
    min-width: 0.5rem;
    text-align: center;
  }
}

.reward-total {
  text-align: center;
  font-size: 0.3rem;
  color: #fff;
  margin-bottom: 0.2rem;

  .reward-total-price {
    color: #d1ae52;
    font-weight: 500;
  }
}

/* 我的帖子列表 */
.profile-posts {
  margin-top: 0.3rem;

  .profile-post-item {
    background: #1a1a1a;
    border-radius: 0.2rem;
    padding: 0.3rem;
    margin-bottom: 0.2rem;

    .post-stats-row {
      display: flex;
      gap: 0.3rem;
      font-size: 0.26rem;
      color: #999;
      margin-top: 0.15rem;
      flex-wrap: wrap;

      .post-stat-item {
        color: #999;
      }
    }
  }
}

/* 关注按钮样式 */
.post-follow-btn {
  &:active {
    opacity: 0.8;
  }
}

/* 资料设置弹框 */
.profile-modal {
  background: #141414 !important;
  border-radius: 0.3rem !important;
  padding: 0.4rem 0.3rem !important;
  max-width: 90%;
  position: relative;
}

.profile-modal-tip {
  font-size: 0.32rem;
  color: #fff;
  text-align: center;
  margin-bottom: 0.3rem;
  font-weight: 500;
}

.profile-modal .form-field {
  margin-bottom: 0.3rem;

  .field-label {
    font-size: 0.28rem;
    color: #ccc;
    margin-bottom: 0.15rem;
  }

  .field-input {
    width: 100%;
    height: 0.8rem;
    background: #1f1f1f;
    border: 1px solid #333;
    border-radius: 0.15rem;
    padding: 0 0.2rem;
    color: #fff;
    font-size: 0.3rem;
    box-sizing: border-box;

    &::placeholder {
      color: #666;
    }
  }
}

.avatar-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.2rem;
  max-height: calc((100% - 0.2rem * 2) / 5 * 3 + 0.2rem * 2);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0.05rem;

  /* 计算约3行头像的高：5列宽平均-约1.35每行*3 + gap*2 = 约  */
  max-height: 4.5rem;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}

.avatar-option {
  aspect-ratio: 1;
  background: #1f1f1f;
  border-radius: 0.15rem;
  overflow: hidden;
  border: 2px solid transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  &.active {
    border-color: #d1ae52;
  }

  .avatar-option-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &.avatar-upload {
    background: #1f1f1f;
    border: 1px dashed #444;
    color: #666;
    font-size: 0.24rem;

    .avatar-upload-plus {
      font-size: 0.5rem;
      line-height: 1;
      margin-bottom: 0.05rem;
    }
  }
}

.textarea-wrap {
  background: #1f1f1f;
  border: 1px solid #333;
  border-radius: 0.15rem;
  padding: 0.2rem;
  position: relative;

  .field-textarea {
    width: 100%;
    min-height: 1.5rem;
    background: transparent;
    border: none;
    outline: none;
    color: #fff;
    font-size: 0.3rem;
    line-height: 1.5;
    resize: none;

    &::placeholder {
      color: #666;
    }
  }

  .textarea-count {
    position: absolute;
    bottom: 0.15rem;
    right: 0.2rem;
    font-size: 0.24rem;
    color: #666;
  }
}

.profile-modal-actions {
  display: flex;
  gap: 0.2rem;
  margin-top: 0.4rem;

  .action-btn {
    flex: 1;
    height: 0.8rem;
    border-radius: 0.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.3rem;
    cursor: pointer;

    &.cancel {
      background: transparent;
      border: 1px solid #666;
      color: #ccc;
    }

    &.confirm {
      background: linear-gradient(135deg, #d1ae52 0%, #b8943f 100%);
      color: #000;
      font-weight: 500;
    }
  }
}

.profile-modal-close {
  position: absolute;
  bottom: -1rem;
  left: 50%;
  transform: translateX(-50%);
  width: 0.7rem;
  height: 0.7rem;
  border: 1px solid #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 0.5rem;
  cursor: pointer;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/plazza.vue